export const LOST_INVITE_STATUS = {
  INVALID: 'invalid',
  DECLINED: 'declined',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
  SENT: 'sent',
};

export const isPendingLostInvite = (inviteData) =>
  Boolean(inviteData) &&
  inviteData.status !== LOST_INVITE_STATUS.INVALID &&
  inviteData.status !== LOST_INVITE_STATUS.DECLINED &&
  inviteData.status !== LOST_INVITE_STATUS.ACCEPTED &&
  inviteData.status !== LOST_INVITE_STATUS.EXPIRED;

export const getLostInviteStatusMessage = (status) => {
  switch (status) {
    case LOST_INVITE_STATUS.DECLINED:
      return 'You have already declined this invitation. Contact your administrator if you need a new invite.';
    case LOST_INVITE_STATUS.ACCEPTED:
      return 'You have already accepted this invitation. Sign in to access your account.';
    case LOST_INVITE_STATUS.EXPIRED:
      return 'This invitation has expired. Contact your administrator to request a new invite.';
    case LOST_INVITE_STATUS.SENT:
      return 'We sent the invitation link to your email. Open that email to accept or decline.';
    case LOST_INVITE_STATUS.INVALID:
    default:
      return "Oops! We couldn't find your invite. A member from our team will reach out to you shortly to get this fixed for you.";
  }
};
